import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import NotFound from '../views/NotFound'
import store from '../store'

Vue.use(VueRouter)

const routes = [
    {
        path: "*",
        component: NotFound
    },
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/buchungen/:id',
        name: 'buchungen',
        meta: {
            cookies: true
        },
        component: () => import(/* webpackChunkName: "buchungen" */ '../views/Bookings.vue')
    },
    {
        path: '/datenschutz',
        name: 'datenschutz',
        component: () => import("../views/Privacy")
    },
    {
        path:'/downloads',
        name: 'downloads',
        component: () => import("../views/Downloads")
    },
    {
        path:'/jubilaeum',
        name: 'jubilaeum',
        component: () => import("../views/Anniversary")
    },
    {
        path:'/downloads/:name',
        name: 'download',
        component: () => import("../views/Download")
    },
    {
        path: '/lk_race',
        name: 'race',
        component: () => import('../views/Race.vue')
    },
    {
        path: '/impressum',
        name: 'impressum',
        component: () => import(/* webpackChunkName: "impressum" */ '../views/Imprint.vue')
    },
    {
        path: '/vorstand',
        name: 'vorstand',
        component: () => import(/* webpackChunkName: "impressum" */ '../views/Management.vue')
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach(function (to, from, next) {
    if (from.name) {
        store.commit('ADD_HISTORY', from.fullPath)
        store.commit('CURRENT_ROUTE', to.name)
    }
    if (to.meta.cookies) {
        let agreed = store.state.cookies
        if (!agreed) {
            next({name: 'home'})
        } else {
            next()
        }
    } else {
        next()
    }
})

export default router
